<script setup>
import { useI18n } from 'vue-i18n'
const { t } = useI18n()
</script>

<script>
import {mapState} from 'pinia';
import {useCompanyStore} from "@dutypay/store-modules";

export default {
  name: 'CompanySettings',
  computed: {
    ...mapState(useCompanyStore, ['hasSelectedCompany'])
  }
}
</script>

<template>
  <div>
    <h1>{{ t('companySettings.title') }}</h1>
    <router-view v-if="hasSelectedCompany"></router-view>
    <p v-else>{{ t('noCompanySelected.label') }}</p>
  </div>
</template>

<i18n>
{
  "ar-AE": {
    "companySettings": {
      "title": "إعدادات الشركة"
    }
  },
  "ar-EG": {
    "companySettings": {
      "title": "إعدادات الشركة"
    }
  },
  "ar-SA": {
    "companySettings": {
      "title": "إعدادات الشركة"
    }
  },
  "de-DE": {
    "companySettings": {
      "title": "Unternehmenseinstellungen"
    }
  },
  "de-AT": {
    "companySettings": {
      "title": "Unternehmenseinstellungen"
    }
  },
  "de-CH": {
    "companySettings": {
      "title": "Unternehmenseinstellungen"
    }
  },
  "en-US": {
    "companySettings": {
      "title": "Company Settings"
    }
  },
  "en-GB": {
    "companySettings": {
      "title": "Company Settings"
    }
  },
  "it-IT": {
    "companySettings": {
      "title": "Impostazioni Azienda"
    }
  },
  "fr-FR": {
    "companySettings": {
      "title": "Paramètres de l'Entreprise"
    }
  },
  "es-ES": {
    "companySettings": {
      "title": "Configuración de la Empresa"
    }
  },
  "pl-PL": {
    "companySettings": {
      "title": "Ustawienia Firmy"
    }
  },
  "nl-NL": {
    "companySettings": {
      "title": "Bedrijfsinstellingen"
    }
  },
  "bg-BG": {
    "companySettings": {
      "title": "Настройки на Kомпанията"
    }
  },
  "bs-BA": {
    "companySettings": {
      "title": "Postavke Kompanije"
    }
  },
  "da-DK": {
    "companySettings": {
      "title": "Virksomhedsindstillinger"
    }
  },
  "et-EE": {
    "companySettings": {
      "title": "Ettevõtte Seaded"
    }
  },
  "fi-FI": {
    "companySettings": {
      "title": "Yrityksen Asetukset"
    }
  },
  "el-GR": {
    "companySettings": {
      "title": "Ρυθμίσεις Εταιρείας"
    }
  },
  "he-IL": {
    "companySettings": {
      "title": "הגדרות חברה"
    }
  },
  "ga-IE": {
    "companySettings": {
      "title": "Socruithe Cuideachta"
    }
  },
  "ja-JP": {
    "companySettings": {
      "title": "会社の設定"
    }
  },
  "hr-HR": {
    "companySettings": {
      "title": "Postavke Tvrtke"
    }
  },
  "lv-LV": {
    "companySettings": {
      "title": "Uzņēmuma Lestatījumi"
    }
  },
  "lt-LT": {
    "companySettings": {
      "title": "Įmonės Nustatymai"
    }
  },
  "pt-PT": {
    "companySettings": {
      "title": "Configurações da Empresa"
    }
  },
  "ro-RO": {
    "companySettings": {
      "title": "Setări Companie"
    }
  },
  "ru-RU": {
    "companySettings": {
      "title": "Настройки Kомпании"
    }
  },
  "sv-SE": {
    "companySettings": {
      "title": "Företagsinställningar"
    }
  },
  "sk-SK": {
    "companySettings": {
      "title": "Nastavenia Spoločnosti"
    }
  },
  "cs-CZ": {
    "companySettings": {
      "title": "Nastavení Společnosti"
    }
  },
  "tr-TR": {
    "companySettings": {
      "title": "Şirket Ayarları"
    }
  },
  "hu-HU": {
    "companySettings": {
      "title": "Vállalati Beállítások"
    }
  },
  "fr-BE": {
    "companySettings": {
      "title": "Paramètres de l'Entreprise"
    }
  },
  "fr-LU": {
    "companySettings": {
      "title": "Paramètres de l'Entreprise"
    }
  },
  "mt-MT": {
    "companySettings": {
      "title": "Settings tal-Kumpanija"
    }
  },
  "sl-SI": {
    "companySettings": {
      "title": "Nastavitve Podjetja"
    }
  },
  "el-CY": {
    "companySettings": {
      "title": "Ρυθμίσεις Εταιρείας"
    }
  },
  "tr-CY": {
    "companySettings": {
      "title": "Şirket Ayarları"
    }
  },
  "uk-UA": {
    "companySettings": {
      "title": "Налаштування Kомпанії"
    }
  },
  "zh-CN": {
    "companySettings": {
      "title": "公司设定"
    }
  }
}
</i18n>
